/**
 * userCommentStyles.tsx — 8211-B
 *
 * Styled components specific to the UserCommentCard edit mode.
 * Shared styles (CardContainer, CardHeaderRow, etc.) come from ./styles.tsx.
 *
 * Reply rendering uses the shared ReplyBox and Reply components from
 * client/src/components/Comment/, so reply-specific styles have been removed.
 */
import styled from "styled-components/macro";
import { themeVariables } from "../../themeVariables";

/** Inline edit textarea */
export const EditTextarea = styled.textarea`
  box-sizing: border-box;
  width: 100%;
  padding: 10px;
  border: 1px solid ${themeVariables.grey3};
  border-radius: 5px;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 1.5;
  text-align: left;
  resize: none;
  overflow: hidden;
  background-color: ${themeVariables.menuColorFullscreen};
  color: ${themeVariables.grey0};
  min-height: 60px;

  &::placeholder {
    color: ${themeVariables.grey2};
  }

  &:focus {
    outline: none;
    border-color: ${themeVariables.primaryCTAHighContrast};
  }
`;

/** Edit action buttons container */
export const EditActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding-top: 8px;
  justify-content: flex-end;
`;

/** Individual edit action button (Save / Cancel) */
export const EditActionButton = styled.div<{ $primary?: boolean }>`
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: ${({ $primary }) =>
    $primary ? themeVariables.primaryCTAHighContrast : themeVariables.grey1};
  user-select: none;
  padding: 4px 8px;
  border-radius: 4px;

  &:hover {
    opacity: 0.7;
  }
`;
